(function () {
"use strict";
function cssNum(n, d) { var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(n)); return v > 0.2 && v < 3 ? v : d; }
var SS = cssNum("--ff-watch-stone-scale", 1), FILL = cssNum("--ff-stone-fill", 1);
if (!window.THREE) {
var ro = document.getElementById("readout"); ro.hidden = false; ro.textContent = "3D library failed to load. Refresh the page.";
return;
}
var STYLES = {
roman:   { name: "Pave, Roman",          full: "Pave dial, Roman numerals",   dial: "Pave, Roman numerals",    kind: "pave",  numerals: "roman",  fam: "iced",
blurb: "Stones edge to edge across the dial, Roman numerals applied over the setting." },
arabic:  { name: "Pave, Arabic",         full: "Pave dial, Arabic numerals",  dial: "Pave, Arabic numerals",   kind: "pave",  numerals: "arabic", fam: "iced",
blurb: "The same pave face with true Arabic numerals, the Eastern Arabic digits an Arabic dial carries." },
red:     { name: "Red sunburst",         full: "Red sunburst dial",           dial: "Solid red sunburst",      kind: "solid", numerals: "roman",  fam: "solid", color: ["#E0574C", "#9E1F17", "#4A0C08"],
blurb: "A clean red sunburst face against the ice. The contrast is what makes the setting read." },
blue:    { name: "Navy sunburst",        full: "Navy sunburst dial",          dial: "Solid navy sunburst",     kind: "solid", numerals: "roman",  fam: "solid", color: ["#4E8FD6", "#123E77", "#06172E"],
blurb: "Deep navy sunburst, the darkest face in the line and the sharpest against white stones." },
green:   { name: "Green sunburst",       full: "Green sunburst dial",         dial: "Solid green sunburst",    kind: "solid", numerals: "roman",  fam: "solid", color: ["#5BC48C", "#146B3F", "#06301B"],
blurb: "Racing green sunburst, warm against gold and cool against steel." },
purple:  { name: "Purple sunburst",      full: "Purple sunburst dial",        dial: "Solid purple sunburst",   kind: "solid", numerals: "roman",  fam: "solid", color: ["#C46BE0", "#6E2297", "#300C48"],
blurb: "A violet sunburst that goes almost black at the edge of the dial." },
white:   { name: "White dial",           full: "White dial",                  dial: "Solid white",             kind: "solid", numerals: "roman",  fam: "solid", color: ["#FFFFFF", "#F1F2F4", "#D5D9DE"], darkText: true,
blurb: "A plain white face. The quietest dial, and the ice does the talking." },
skel:    { name: "Skeleton",             full: "Skeleton dial",               dial: "Skeleton, open movement", kind: "skel",  numerals: "roman",  fam: "skel",
blurb: "The dial cut away so the movement shows through, with the bridges set in stones." }
};
var STONES = {
moiss: { name: "Moissanite",  full: "Moissanite",        base: 750,  blurb: "Brighter than diamond per carat, and it is what the whole line is built on. Stated honestly, never sold as diamond." },
lab:   { name: "Lab diamond", full: "Lab-grown diamond", base: 3500, blurb: "Grown, not mined. Chemically and optically diamond, certified as lab-grown, at a fraction of a mined stone." }
};
var TONES = {
gold:  { name: "Gold",      col: 0xC9971F, rough: 0.19, sw: "linear-gradient(135deg,#F5DA97,#C89320 55%,#8A6415)" },
white: { name: "Silver",    col: 0xC9D2DC, rough: 0.14, sw: "linear-gradient(135deg,#F4F7FA,#B7C1CB 55%,#78838E)" },
rose:  { name: "Rose gold", col: 0xD28E6E, rough: 0.19, sw: "linear-gradient(135deg,#F7CDB6,#D18C6D 55%,#95533B)" }
};
var WVARIANTS = {
icednum: { moiss: { white: "51006658412787", rose: "51006658445555", gold: "51006658478323" }, lab: { white: "51006658609395", rose: "51006658642163", gold: "51006658674931" } },
iced:  { moiss: { white: "51006658019571", rose: "51006658052339", gold: "51006658085107" }, lab: { white: "51006658216179", rose: "51006658248947", gold: "51006658281715" } },
solid: { moiss: { white: "51006658806003", rose: "51006658838771", gold: "51006658871539" }, lab: { white: "51006659002611", rose: "51006659035379", gold: "51006659068147" } },
skel:  { moiss: { white: "51006659199219", rose: "51006659231987", gold: "51006659264755" }, lab: { white: "51006659395827", rose: "51006659428595", gold: "51006659461363" } }
};
var NUMCOL = {
white:   { name: "White",   col: "#F4F8FF" },
black:   { name: "Black",   col: "#15181D" },
red:     { name: "Red",     col: "#E24B3B" },
orange:  { name: "Orange",  col: "#F0912E" },
yellow:  { name: "Yellow",  col: "#F2D23A" },
green:   { name: "Green",   col: "#4CBF6A" },
blue:    { name: "Blue",    col: "#3C86E0" },
purple:  { name: "Purple",  col: "#7A4FD6" },
pink:    { name: "Pink",    col: "#F06AA8" },
rainbow: { name: "Rainbow", col: null, sw: "conic-gradient(#E24B3B,#F2D23A,#4CBF6A,#3C86E0,#7A4FD6,#E24B3B)" }
};
var RAINBOW = ["#E24B3B", "#F0912E", "#F2D23A", "#4CBF6A", "#3C86E0", "#7A4FD6"];
function numeralFill(i) { var N = NUMCOL[state.num] || NUMCOL.white; return N.col || RAINBOW[i % RAINBOW.length]; }
function familyOf(S) { if (S.kind === "pave" && state.num !== "white") return "icednum"; return S.fam; }
var SHOP_BASE = (typeof location !== "undefined" && /(^|\.)flexfactoryice\.com$|\.myshopify\.com$/i.test(location.hostname || "")) ? "" : "https://flexfactoryice.com";
var TERMS_VERSION = "2026-09-20";
var TERMS = [
"Every watch is set to order. It takes about a week on the bench from the day you order. Shipping time is on top of that and depends on where you are.",
"The movement is automatic and carries a two year mechanical warranty. A stone lost inside the first year is reset at no charge.",
"We state which stone you bought. Moissanite is sold as moissanite and never as diamond; lab-grown diamond is sold as lab-grown and never as mined, and ships with its certificate.",
"You see photographs of the finished watch before it leaves the bench. If something is off, it goes back.",
"Because each watch is set to your specification it is made for you alone. It is a final sale: it cannot be returned, exchanged or refunded for a change of mind. Faults are still ours to fix: the movement carries its two year mechanical warranty and a stone lost in the first year is reset at no charge."
];
function money(n) { return "$" + n.toLocaleString("en-US"); }
var state = { style: "roman", tone: "white", stone: "moiss", num: "white", bare: false };
function checkoutURL() {
var S = STYLES[state.style], fam = familyOf(S);
var v = WVARIANTS[fam] && WVARIANTS[fam][state.stone] && WVARIANTS[fam][state.stone][state.tone];
if (!v) return "";
var a = [];
function add(k, val) { if (val) a.push("attributes[" + encodeURIComponent(k) + "]=" + encodeURIComponent(val)); }
add("Style", S.full + ", " + TONES[state.tone].name.toLowerCase());
add("Dial", S.dial);
add("Numerals", NUMCOL[state.num].name + ", " + (S.numerals === "arabic" ? "Arabic" : "Roman"));
add("Stone", STONES[state.stone].full);
add("Metal tone", TONES[state.tone].name);
add("Stone cut", "Round pave");
add("Crown", "Plain metal, no cabochon");
add("Movement", "Automatic, sapphire crystal");
add("Build time", "1 week on the bench, then shipping");
add("Terms", "Accepted in the 3D studio - v" + TERMS_VERSION);
add("Built with", "3D watch studio");
return SHOP_BASE + "/cart/" + v + ":1?" + a.join("&");
}
function roundedRect(w, h, r) {
var s = new THREE.Shape(), x = -w / 2, y = -h / 2;
s.moveTo(x + r, y);
s.lineTo(x + w - r, y); s.quadraticCurveTo(x + w, y, x + w, y + r);
s.lineTo(x + w, y + h - r); s.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
s.lineTo(x + r, y + h); s.quadraticCurveTo(x, y + h, x, y + h - r);
s.lineTo(x, y + r); s.quadraticCurveTo(x, y, x + r, y);
return s;
}
function inRR(x, y, w, h, r) {
var hx = w / 2 - r, hy = h / 2 - r;
var dx = Math.max(Math.abs(x) - hx, 0), dy = Math.max(Math.abs(y) - hy, 0);
return dx * dx + dy * dy <= r * r;
}
function hexField(w, h, r, keep, out, seed) {
var rnd = seeded(seed || 11), dx = r * 1.98, dy = dx * 0.866, row = 0, x, y;
for (y = -h / 2 + r; y <= h / 2; y += dy, row++) {
var off = (row % 2) ? dx / 2 : 0;
for (x = -w / 2 + off + r; x <= w / 2; x += dx) {
if (keep(x, y, r)) out.push({ x: x, y: y, r: r * (0.99 + rnd() * 0.06) });
}
}
return out;
}
function seeded(s) { return function () { s = (s * 9301 + 49297) % 233280; return s / 233280; }; }
var ROMAN = ["XII", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI"];
var ARABIC = ["١٢", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩", "١٠", "١١"];
function sqPoint(i, half, inset) {
var a = (i / 12) * Math.PI * 2 - Math.PI / 2, ca = Math.cos(a), sa = Math.sin(a);
var m = Math.max(Math.abs(ca), Math.abs(sa));
return [(ca / m) * (half - inset), (sa / m) * (half - inset)];
}
function dialTexture(S, toneHex) {
var N = 1024, c = document.createElement("canvas"); c.width = c.height = N;
var x = c.getContext("2d"), cx = N / 2, cy = N / 2, i;
x.clearRect(0, 0, N, N);
if (S.kind === "solid") {
var g = x.createRadialGradient(cx - 120, cy - 160, 40, cx, cy, N * 0.72);
g.addColorStop(0, S.color[0]); g.addColorStop(0.55, S.color[1]); g.addColorStop(1, S.color[2]);
x.fillStyle = g; x.fillRect(0, 0, N, N);
x.save(); x.translate(cx, cy); x.globalAlpha = 0.16;
for (i = 0; i < 360; i += 2) { x.rotate(2 * Math.PI / 180); x.fillStyle = (i % 4) ? "#FFFFFF" : "#000000"; x.fillRect(0, -1.2, N, 2.4); }
x.restore();
} else if (S.kind === "skel") {
x.fillStyle = "#2E333B"; x.fillRect(0, 0, N, N);
var fl = x.createRadialGradient(cx, cy, 80, cx, cy, 560); fl.addColorStop(0, "rgba(255,255,255,.10)"); fl.addColorStop(1, "rgba(0,0,0,.45)");
x.fillStyle = fl; x.fillRect(0, 0, N, N);
function gear(gx, gy, R, teeth, col) {
x.save(); x.translate(gx, gy); x.fillStyle = col; x.strokeStyle = "#B8C1CC"; x.lineWidth = 6;
x.beginPath(); x.arc(0, 0, R, 0, Math.PI * 2); x.fill(); x.stroke();
for (var k = 0; k < teeth; k++) { x.rotate(Math.PI * 2 / teeth); x.fillStyle = "#AEB8C4"; x.fillRect(R - 4, -7, 22, 14); }
x.fillStyle = "#1A1E24"; x.beginPath(); x.arc(0, 0, R * 0.32, 0, Math.PI * 2); x.fill();
x.restore();
}
gear(cx - 150, cy - 120, 150, 28, "#6B7480"); gear(cx + 190, cy + 170, 105, 20, "#5F6873"); gear(cx + 60, cy - 250, 60, 14, "#747D88");
x.save(); x.translate(cx, cy);
for (i = 0; i < 4; i++) { x.rotate(i ? Math.PI / 4 : 0); var bg = x.createLinearGradient(-60, 0, 60, 0); bg.addColorStop(0, "#9AA3AE"); bg.addColorStop(0.5, "#E3E8EE"); bg.addColorStop(1, "#8A939E"); x.fillStyle = bg; x.fillRect(-52, -N, 104, N * 2); }
x.restore();
[[-150, -120], [190, 170], [0, 0], [-250, 150], [230, -200], [60, -300], [-80, 290]].forEach(function (j) {
x.fillStyle = "#C2185B"; x.beginPath(); x.arc(cx + j[0], cy + j[1], 16, 0, Math.PI * 2); x.fill();
x.fillStyle = "#FF8FB8"; x.beginPath(); x.arc(cx + j[0] - 5, cy + j[1] - 5, 6, 0, Math.PI * 2); x.fill();
});
}
var dark = (S.kind === "pave") || !!S.darkText;
x.strokeStyle = dark ? "rgba(20,24,30,.85)" : "rgba(255,255,255,.85)"; x.lineWidth = 6;
x.strokeRect(cx - 300, cy - 300, 600, 600);
x.lineWidth = 2; x.strokeStyle = dark ? "rgba(20,24,30,.5)" : "rgba(255,255,255,.45)";
for (i = 0; i < 60; i++) { var p = sqPoint(i / 5, 300, 0); x.beginPath(); x.moveTo(cx + p[0] * 0.965, cy + p[1] * 0.965); x.lineTo(cx + p[0], cy + p[1]); x.stroke(); }
x.textAlign = "center"; x.textBaseline = "middle";
for (i = 0; i < 12; i++) {
var pt = sqPoint(i, 420, 0), big = (i % 3 === 0);
var label = S.numerals === "arabic" ? ARABIC[i] : ROMAN[i];
x.font = (big ? "600 112px" : "600 92px") + (S.numerals === "arabic" ? " 'Noto Naskh Arabic','Geeza Pro','Arial',sans-serif" : " 'Times New Roman',Georgia,serif");
var fillCol = numeralFill(i), lightNum = fillCol !== "#15181D";
x.lineJoin = "round"; x.lineWidth = (S.kind === "pave") ? 14 : 7;
x.strokeStyle = (S.kind === "pave" || S.darkText) ? (lightNum ? "#1B1F26" : "#E8EDF3") : (lightNum ? "rgba(10,12,16,.55)" : "rgba(255,255,255,.75)");
x.strokeText(label, cx + pt[0], cy + pt[1]);
x.fillStyle = fillCol;
x.fillText(label, cx + pt[0], cy + pt[1]);
}
x.font = "500 30px 'JetBrains Mono',monospace"; x.fillStyle = dark ? "#1B1F26" : "rgba(255,255,255,.75)";
if (S.kind === "pave") { x.fillStyle = "rgba(10,12,16,.55)"; x.fillRect(cx - 150, cy + 120, 300, 50); x.fillStyle = "#D6E0EA"; }
x.fillText("A U T O M A T I C", cx, cy + 146);
if (S.kind !== "skel") {
x.fillStyle = "#C9D2DC"; x.fillRect(cx - 44, cy + 196, 88, 70);
x.fillStyle = "#F7F8FA"; x.fillRect(cx - 38, cy + 202, 76, 58);
x.fillStyle = "#15181D"; x.font = "600 46px 'Barlow',Arial,sans-serif"; x.fillText(String(new Date().getDate()), cx, cy + 232);
}
var tex = new THREE.CanvasTexture(c); tex.anisotropy = 4; tex.encoding = THREE.sRGBEncoding;
return tex;
}
var cvs = document.getElementById("gl");
var renderer, scene, camera, root, env, keyLight, rimLight;
var metalMat, stoneMat, glassMat, handMat, darkMat;
var cam = { az: 0, el: 0.34, dist: 190, tAz: 0, tEl: 0.34, tDist: 150 };
var spin = true, dragging = false, lastX = 0, lastY = 0, userZoomed = false, swayT = 0;
var clock = { t: 0, last: 0, w: 0 };
var anim = { stones: [], setStart: 0, setDur: 1.35, settling: false, flashes: [], metalTo: null, introDone: false };
function studioEnv(r) {
var c = document.createElement("canvas"); c.width = 1024; c.height = 512;
var x = c.getContext("2d");
var g = x.createLinearGradient(0, 0, 0, 512);
g.addColorStop(0, "#0C1119"); g.addColorStop(0.46, "#070910"); g.addColorStop(0.52, "#0B0E16"); g.addColorStop(1, "#020306");
x.fillStyle = g; x.fillRect(0, 0, 1024, 512);
[[150, 86, 74, 1.0], [620, 70, 56, 0.85], [400, 150, 30, 0.45], [880, 120, 40, 0.5]].forEach(function (s) {
var rg = x.createRadialGradient(s[0] + s[2] / 2, s[1] + s[3] / 2, 2, s[0] + s[2] / 2, s[1] + s[3] / 2, s[2]);
rg.addColorStop(0, "rgba(255,255,255," + s[3] + ")"); rg.addColorStop(1, "rgba(255,255,255,0)");
x.fillStyle = rg; x.fillRect(s[0] - s[2], s[1] - s[2], s[2] * 3, s[2] * 3);
});
x.fillStyle = "rgba(120,160,255,.10)"; x.fillRect(0, 300, 1024, 212);
[[0, 200, 1024, 110, 0.22], [230, 230, 60, 60, 0.6], [790, 230, 60, 60, 0.6]].forEach(function (b) {
var lg = x.createLinearGradient(0, b[1], 0, b[1] + b[3]);
lg.addColorStop(0, "rgba(255,250,240,0)"); lg.addColorStop(0.5, "rgba(255,250,240," + b[4] + ")"); lg.addColorStop(1, "rgba(255,250,240,0)");
x.fillStyle = lg; x.fillRect(b[0], b[1], b[2], b[3]);
});
var seed = 7, k;
function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
for (k = 0; k < 70; k++) {
var sx = rnd() * 1024, sy = 20 + rnd() * 250, sr = 2.5 + rnd() * 5, sa = 0.55 + rnd() * 0.45;
var pg = x.createRadialGradient(sx, sy, 0, sx, sy, sr);
pg.addColorStop(0, "rgba(255,255,255," + sa + ")"); pg.addColorStop(0.45, "rgba(255,255,255," + (sa * 0.5) + ")"); pg.addColorStop(1, "rgba(255,255,255,0)");
x.fillStyle = pg; x.fillRect(sx - sr, sy - sr, sr * 2, sr * 2);
}
var tex = new THREE.CanvasTexture(c); tex.mapping = THREE.EquirectangularReflectionMapping;
var p = new THREE.PMREMGenerator(r); p.compileEquirectangularShader();
var t = p.fromEquirectangular(tex).texture; p.dispose(); tex.dispose();
return t;
}
function init() {
renderer = new THREE.WebGLRenderer({ canvas: cvs, antialias: true, alpha: true });
renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 1.05;
scene = new THREE.Scene();
camera = new THREE.PerspectiveCamera(30, 1, 1, 900);
env = studioEnv(renderer); scene.environment = env;
scene.add(new THREE.AmbientLight(0xffffff, 0.12));
keyLight = new THREE.DirectionalLight(0xffffff, 1.9); keyLight.position.set(26, 42, 58); scene.add(keyLight);
rimLight = new THREE.DirectionalLight(0xBFD4FF, 0.8); rimLight.position.set(-44, 14, -36); scene.add(rimLight);
var fill = new THREE.DirectionalLight(0xFFE7BF, 0.4); fill.position.set(-20, -34, 30); scene.add(fill);
var T = TONES[state.tone];
metalMat = new THREE.MeshStandardMaterial({ color: T.col, metalness: 1.0, roughness: T.rough, envMapIntensity: 1.5 });
stoneMat = new THREE.MeshPhysicalMaterial({ color: 0xF4F8FF, metalness: 0.72, roughness: 0.025, clearcoat: 1.0, clearcoatRoughness: 0.02, envMapIntensity: 2.2, reflectivity: 1.0, flatShading: true });
glassMat = new THREE.MeshPhysicalMaterial({ color: 0xFFFFFF, metalness: 0.0, roughness: 0.02, transparent: true, opacity: 0.10, envMapIntensity: 1.2, clearcoat: 1.0, depthWrite: false });
handMat = new THREE.MeshStandardMaterial({ color: 0x2C63B4, metalness: 0.85, roughness: 0.25, envMapIntensity: 1.3 });
darkMat = new THREE.MeshStandardMaterial({ color: 0x14171C, metalness: 0.4, roughness: 0.6 });
root = new THREE.Group(); scene.add(root);
resize(); window.addEventListener("resize", resize);
}
var sizeW = -1, sizeH = -1;
function resize() {
var w = cvs.clientWidth, h = cvs.clientHeight;
if (!w || !h) return false;
if (w === sizeW && h === sizeH) return true;
sizeW = w; sizeH = h;
renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
renderer.setSize(w, h, false);
camera.aspect = w / h; camera.updateProjectionMatrix();
if (!userZoomed) frameCamera();
return true;
}
function clearRoot() {
for (var i = root.children.length - 1; i >= 0; i--) {
var o = root.children[i];
if (o === dialMesh) dialMesh = null;
o.traverse(function (c) { if (c.geometry) c.geometry.dispose(); if (c.material && c.material.map && c.userData.ownsMap) { c.material.map.dispose(); c.material.dispose(); } });
root.remove(o);
}
anim.stones = []; anim.flashes = [];
root.position.set(0, 0, 0); root.rotation.set(0, 0, 0); root.updateMatrixWorld(true);
}
var _m = new THREE.Matrix4(), _q = new THREE.Quaternion(), _p = new THREE.Vector3(), _sc = new THREE.Vector3(),
_wp = new THREE.Vector3(), _wq = new THREE.Quaternion(), _ws = new THREE.Vector3(), _n = new THREE.Vector3(),
_white = new THREE.Color(1, 1, 1), _flash = new THREE.Color();
function makeInstanced(geo, list) {
var mesh = new THREE.InstancedMesh(geo, stoneMat, list.length);
var rec = { mesh: mesh, pos: [], quat: [], scl: [], delay: [] };
var minY = Infinity, maxY = -Infinity, i;
for (i = 0; i < list.length; i++) {
list[i].decompose(_wp, _wq, _ws);
rec.pos.push(_wp.clone()); rec.quat.push(_wq.clone()); rec.scl.push(_ws.clone());
if (_wp.y < minY) minY = _wp.y; if (_wp.y > maxY) maxY = _wp.y;
mesh.setColorAt(i, _white);
}
var span = Math.max(1, maxY - minY);
for (i = 0; i < list.length; i++) {
rec.delay.push(Math.abs(rec.pos[i].y) / (span / 2) * 0.78 + Math.random() * 0.17);
_m.compose(rec.pos[i], rec.quat[i], _sc.set(0.0001, 0.0001, 0.0001));
mesh.setMatrixAt(i, _m);
}
mesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
if (mesh.instanceColor) { mesh.instanceColor.setUsage(THREE.DynamicDrawUsage); mesh.instanceColor.needsUpdate = true; }
mesh.instanceMatrix.needsUpdate = true;
return rec;
}
function addStones(list, spots, partMatrix, zTop, lift) {
spots.forEach(function (s) {
var crown = s.r * 0.80;
_p.set(s.x, s.y, zTop + crown * 0.40 - 0.03 + (lift || 0));
_q.set(0.7071067811865476, 0, 0, 0.7071067811865476);
_sc.set(s.r * FILL, crown, s.r * FILL);
_m.compose(_p, _q, _sc);
list.push(new THREE.Matrix4().multiplyMatrices(partMatrix, _m));
});
}
var CASE_W = 40, CASE_H = 40, CASE_R = 7, CASE_T = 5;
var BEZ_O = 34, BEZ_I = 26.5, BEZ_T = 3.2;
var DIAL = 26;
function build() {
clearRoot();
var S = STYLES[state.style];
var rounds = [];
var stoneCt = 0;
var caseGeo = new THREE.ExtrudeGeometry(roundedRect(CASE_W, CASE_H, CASE_R), { depth: CASE_T, bevelEnabled: true, bevelThickness: 1.2, bevelSize: 1.2, bevelSegments: 4, steps: 1 });
var caseM = new THREE.Mesh(caseGeo, metalMat); caseM.position.z = -CASE_T; caseM.userData.isWatch = true; root.add(caseM);
var lugGeo = new THREE.ExtrudeGeometry(roundedRect(28, 10, 3), { depth: CASE_T - 0.8, bevelEnabled: true, bevelThickness: 1, bevelSize: 1, bevelSegments: 3, steps: 1 });
[1, -1].forEach(function (sg) { var l = new THREE.Mesh(lugGeo, metalMat); l.position.set(0, sg * 22, -CASE_T + 0.2); l.userData.isWatch = true; root.add(l); });
var bezShape = roundedRect(BEZ_O, BEZ_O, 5.5); bezShape.holes.push(roundedRect(BEZ_I, BEZ_I, 4.2));
var bezGeo = new THREE.ExtrudeGeometry(bezShape, { depth: BEZ_T, bevelEnabled: true, bevelThickness: 0.5, bevelSize: 0.5, bevelSegments: 3, steps: 1 });
var bez = new THREE.Mesh(bezGeo, metalMat); bez.position.z = 0; bez.userData.isWatch = true; root.add(bez);
var SCREWS = [[-14, -14], [14, -14], [14, 14], [-14, 14], [0, -15.6], [15.6, 0], [0, 15.6], [-15.6, 0]];
var scrGeo = new THREE.CylinderGeometry(1.25, 1.25, 1.2, 18); scrGeo.rotateX(Math.PI / 2);
var slotGeo = new THREE.BoxGeometry(1.7, 0.32, 0.3);
SCREWS.forEach(function (sp, i) {
var sc = new THREE.Mesh(scrGeo, metalMat); sc.position.set(sp[0], sp[1], BEZ_T + 0.6); root.add(sc);
var sl = new THREE.Mesh(slotGeo, darkMat); sl.position.set(sp[0], sp[1], BEZ_T + 1.2); sl.rotation.z = (i % 2) ? 0.5 : -0.3; root.add(sl);
});
var tex = dialTexture(S);
var dialMat = new THREE.MeshStandardMaterial({ map: tex, transparent: S.kind === "pave", alphaTest: S.kind === "pave" ? 0.08 : 0, metalness: S.kind === "solid" ? 0.35 : 0.1, roughness: S.kind === "solid" ? 0.35 : 0.6, envMapIntensity: 0.8 });
var DZ = 1.25;
var dial = new THREE.Mesh(new THREE.PlaneGeometry(DIAL, DIAL), dialMat); dial.position.z = (S.kind === "pave") ? DZ + 1.3 : DZ + 0.05; dial.userData.ownsMap = true; dial.renderOrder = 2; root.add(dial); dialMesh = dial;
function hand(len, w, ang) {
var g = new THREE.BoxGeometry(w, len, 0.35); g.translate(0, len / 2 - 1.2, 0);
var h = new THREE.Mesh(g, handMat); h.rotation.z = -ang; h.position.z = DZ + 1.75; h.renderOrder = 3; return h;
}
root.add(hand(10.5, 1.35, -0.56)); root.add(hand(8.2, 1.9, 2.05));
var cap = new THREE.Mesh(new THREE.CylinderGeometry(1.0, 1.0, 0.7, 16), metalMat); cap.rotation.x = Math.PI / 2; cap.position.z = DZ + 1.9; root.add(cap);
var crown = new THREE.Mesh(new THREE.CylinderGeometry(2.1, 2.1, 3.2, 24), metalMat);
crown.rotation.z = Math.PI / 2; crown.position.set(CASE_W / 2 + 2.2, 0, -CASE_T / 2); crown.userData.isWatch = true; root.add(crown);
var cgrip = new THREE.Mesh(new THREE.CylinderGeometry(2.35, 2.35, 1.2, 10), metalMat);
cgrip.rotation.z = Math.PI / 2; cgrip.position.set(CASE_W / 2 + 3.4, 0, -CASE_T / 2); root.add(cgrip);
var nLinks = 13, pitch = 6.9, LT = 3.2, linkMats = [], CLASP_W = 21, CLASP_L = 14, endY = CLASP_L / 2 - 1.0;
var y0 = 27.0 + 0.1;
function sweep(g) { var s = 0, a = []; for (var i = 0; i < nLinks; i++) { var f = Math.PI * Math.pow((i + 0.5) / nLinks, g); a.push(f); s += pitch * Math.cos(f); } return { s: s, a: a }; }
var lo = 0.3, hi = 2.5, gam;
for (var it = 0; it < 48; it++) { gam = (lo + hi) / 2; if (sweep(gam).s > -(y0 - endY)) hi = gam; else lo = gam; }
var angles = sweep(lo).a, endZ = 0;
[1, -1].forEach(function (sg) {
var y = y0, z = -0.2;
for (var i = 0; i < nLinks; i++) {
var phi = angles[i], w = Math.max(20, 26 - i * 1.1), lh = 6.4;
var cy = y + (pitch / 2) * Math.cos(phi), cz = z - (pitch / 2) * Math.sin(phi);
var grp = new THREE.Group();
grp.position.set(0, sg * cy, cz);
grp.rotation.x = -sg * phi;
var lg = new THREE.ExtrudeGeometry(roundedRect(w, lh, 1.6), { depth: LT, bevelEnabled: true, bevelThickness: 0.6, bevelSize: 0.6, bevelSegments: 3, steps: 1 });
var lm = new THREE.Mesh(lg, metalMat); lm.position.z = -LT; lm.userData.isWatch = true; grp.add(lm);
[-1, 1].forEach(function (ss) { var sc2 = new THREE.Mesh(scrGeo, metalMat); sc2.position.set(ss * (w / 2 - 2.4), 0, 0.5); sc2.scale.set(0.8, 0.8, 0.8); grp.add(sc2); });
root.add(grp); grp.updateMatrixWorld(true);
linkMats.push({ m: grp.matrixWorld.clone(), w: w, h: lh });
y += pitch * Math.cos(phi); z -= pitch * Math.sin(phi);
}
endZ = z;
});
var clasp = new THREE.Group(); clasp.position.set(0, 0, endZ); clasp.rotation.x = Math.PI;
var cg = new THREE.ExtrudeGeometry(roundedRect(CLASP_W, CLASP_L, 2.2), { depth: LT, bevelEnabled: true, bevelThickness: 0.6, bevelSize: 0.6, bevelSegments: 3, steps: 1 });
var cm = new THREE.Mesh(cg, metalMat); cm.position.z = -LT; cm.userData.isWatch = true; clasp.add(cm);
[-1, 1].forEach(function (ss) { var pb = new THREE.Mesh(new THREE.BoxGeometry(2.2, 5, 2.2), metalMat); pb.position.set(ss * (CLASP_W / 2 + 1.3), 0, -LT / 2); clasp.add(pb); });
var seam = new THREE.Mesh(new THREE.BoxGeometry(CLASP_W - 3, 0.35, 0.3), darkMat); seam.position.set(0, 0, 0.55); clasp.add(seam);
root.add(clasp); clasp.updateMatrixWorld(true);
linkMats.push({ m: clasp.matrixWorld.clone(), w: CLASP_W, h: CLASP_L, clasp: true });
if (!state.bare) {
var I = new THREE.Matrix4();
var caseSpots = hexField(CASE_W, CASE_H, 0.58 * SS, function (x, y, r) { return inRR(x, y, CASE_W - 1.1, CASE_H - 1.1, CASE_R - 0.6) && !inRR(x, y, BEZ_O + 0.7, BEZ_O + 0.7, 5.8); }, [], 3);
addStones(rounds, caseSpots, I, 1.2);
[1, -1].forEach(function (sx) {
var F = new THREE.Matrix4().makeBasis(new THREE.Vector3(0, sx, 0), new THREE.Vector3(0, 0, 1), new THREE.Vector3(sx, 0, 0));
F.setPosition(sx * (CASE_W / 2 + 1.2), 0, -CASE_T / 2);
var fs = hexField(CASE_H - 2 * CASE_R + 2, CASE_T - 0.4, 0.5 * SS, function (x, y, r) { return (sx < 0) || Math.abs(x) > 3.4; }, [], 31 + sx);
addStones(rounds, fs, F, 0);
});
[[1, 0], [-1, 0], [0, 1], [0, -1]].forEach(function (d, di) {
var zAx = new THREE.Vector3(d[0], d[1], 0), yAx = new THREE.Vector3(0, 0, 1), xAx = new THREE.Vector3().crossVectors(yAx, zAx);
var F = new THREE.Matrix4().makeBasis(xAx, yAx, zAx); F.setPosition(d[0] * (BEZ_O / 2 + 0.5), d[1] * (BEZ_O / 2 + 0.5), BEZ_T / 2);
var fs = hexField(BEZ_O - 10, BEZ_T - 0.3, 0.47 * SS, function () { return true; }, [], 41 + di);
addStones(rounds, fs, F, 0);
});
var lugSpots = [];
hexField(28, 10, 0.58 * SS, function (x, y, r) { return inRR(x, y, 27.2, 9.2, 2.6); }, lugSpots, 5);
lugSpots.forEach(function (s) { addStones(rounds, [{ x: s.x, y: s.y + 22, r: s.r }], I, 0.4); addStones(rounds, [{ x: s.x, y: s.y - 22, r: s.r }], I, 0.4); });
var bezSpots = hexField(BEZ_O, BEZ_O, 0.54 * SS, function (x, y, r) {
if (!inRR(x, y, BEZ_O - 1.0, BEZ_O - 1.0, 5.0)) return false;
if (inRR(x, y, BEZ_I + 1.1, BEZ_I + 1.1, 4.6)) return false;
for (var k = 0; k < SCREWS.length; k++) { var dx = x - SCREWS[k][0], dy = y - SCREWS[k][1]; if (dx * dx + dy * dy < 2.0 * 2.0) return false; }
return true;
}, [], 9);
addStones(rounds, bezSpots, I, BEZ_T + 0.5);
if (S.kind === "pave") {
var dialSpots = hexField(DIAL, DIAL, 0.42 * SS, function (x, y, r) { return inRR(x, y, DIAL - 0.7, DIAL - 0.7, 2.3); }, [], 13);
addStones(rounds, dialSpots, I, DZ);
}
if (S.kind === "skel") {
var skSpots = hexField(DIAL, DIAL, 0.4 * SS, function (x, y, r) {
var onCross = Math.abs(x) < 1.5 || Math.abs(y) < 1.5;
var d1 = Math.abs(x - y) / 1.4142, d2 = Math.abs(x + y) / 1.4142;
return inRR(x, y, DIAL - 1.2, DIAL - 1.2, 2.5) && (onCross || d1 < 1.1 || d2 < 1.1);
}, [], 17);
addStones(rounds, skSpots, I, DZ + 0.05);
}
linkMats.forEach(function (L, li) {
var sp = hexField(L.w, L.h, 0.56 * SS, function (x, y, r) {
if (!inRR(x, y, L.w - 0.9, L.h - 0.6, 1.1)) return false;
if (L.clasp) return true;
return Math.abs(Math.abs(x) - (L.w / 2 - 2.4)) > 1.75 || Math.abs(y) > 1.5;
}, [], 21 + li);
addStones(rounds, sp, L.m, 0.6);
if (L.clasp) return;
[1, -1].forEach(function (sx) {
var F = new THREE.Matrix4().makeBasis(new THREE.Vector3(0, sx, 0), new THREE.Vector3(0, 0, 1), new THREE.Vector3(sx, 0, 0));
F.setPosition(sx * (L.w / 2 + 0.6), 0, -LT / 2);
F.premultiply(L.m);
var es = hexField(L.h - 2.4, LT - 0.5, 0.46 * SS, function () { return true; }, [], 61 + li * 2 + sx);
addStones(rounds, es, F, 0);
});
});
stoneCt = rounds.length;
var rg = new THREE.CylinderGeometry(0.46, 1.0, 1.0, 16, 1, false);
var r1 = makeInstanced(rg, rounds); root.add(r1.mesh); anim.stones.push(r1);
}
root.updateMatrixWorld(true);
var box = new THREE.Box3();
root.traverse(function (o) { if (o.isMesh && o.userData.isWatch) box.expandByObject(o); });
var c = box.getCenter(new THREE.Vector3());
root.position.set(-c.x, -c.y, -c.z * 0.55);
fitSpan = box.getSize(new THREE.Vector3());
frameCamera();
anim.setStart = clock.w; anim.settling = !state.bare;
paintReadout(stoneCt);
}
var dialMesh = null;
function retexture() {
if (!dialMesh) { build(); return; }
var old = dialMesh.material.map; dialMesh.material.map = dialTexture(STYLES[state.style]); dialMesh.material.needsUpdate = true; if (old) old.dispose();
}
var fitSpan = null;
function frameCamera() {
if (!fitSpan) return;
var half = Math.tan((camera.fov / 2) * Math.PI / 180);
var byH = (Math.min(fitSpan.y, 92) * 1.05 + 10) / (2 * half);
var byW = (fitSpan.x * 1.2 + 8) / (2 * half * Math.max(0.5, camera.aspect));
cam.tDist = Math.max(40, Math.max(byH, byW) * 1.12);
}
function easeBack(t) { var c1 = 1.70158, c3 = c1 + 1; return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2); }
function stepSetting() {
if (!anim.settling) return;
var el = clock.w - anim.setStart, done = true, k;
anim.stones.forEach(function (rec) {
var n = rec.pos.length, i;
for (i = 0; i < n; i++) {
var t = (el - rec.delay[i] * anim.setDur) / 0.38;
if (t < 0) { done = false; continue; }
if (t >= 1) k = 1; else { k = easeBack(t); done = false; }
_sc.copy(rec.scl[i]).multiplyScalar(Math.max(0.0001, k));
_wp.copy(rec.pos[i]);
if (t < 1) { _n.set(0, 1, 0).applyQuaternion(rec.quat[i]); _wp.addScaledVector(_n, (1 - t) * 1.6); }
_m.compose(_wp, rec.quat[i], _sc);
rec.mesh.setMatrixAt(i, _m);
}
rec.mesh.instanceMatrix.needsUpdate = true;
});
if (done) anim.settling = false;
}
var TINTS = [[1, 1, 1], [1, 1, 1], [0.6, 0.78, 1], [1, 0.62, 0.62], [1, 0.9, 0.5], [0.62, 1, 0.72], [0.9, 0.62, 1]];
function stepFire(dt) {
if (!anim.stones.length || anim.settling) return;
var total = 0; anim.stones.forEach(function (r) { total += r.pos.length; });
var want = total / 22, i, spawn = (want / 0.55) * dt;
while (spawn > 0) {
if (Math.random() < spawn) {
var rec = anim.stones[Math.floor(Math.random() * anim.stones.length)];
anim.flashes.push({ rec: rec, i: Math.floor(Math.random() * rec.pos.length), t0: clock.w, dur: 0.35 + Math.random() * 0.5, tint: TINTS[Math.floor(Math.random() * TINTS.length)], amp: 2.5 + Math.random() * 4.5 });
}
spawn -= 1;
}
var touched = new Set();
for (i = anim.flashes.length - 1; i >= 0; i--) {
var f = anim.flashes[i], life = (clock.w - f.t0) / f.dur;
if (life >= 1) { f.rec.mesh.setColorAt(f.i, _white); touched.add(f.rec.mesh); anim.flashes.splice(i, 1); continue; }
var s = Math.sin(life * Math.PI); s = s * s * f.amp;
_flash.setRGB(1 + s * f.tint[0], 1 + s * f.tint[1], 1 + s * f.tint[2]);
f.rec.mesh.setColorAt(f.i, _flash); touched.add(f.rec.mesh);
}
touched.forEach(function (m) { if (m.instanceColor) m.instanceColor.needsUpdate = true; });
}
function stepMetal() {
if (!anim.metalTo) return;
var M = anim.metalTo, done = true;
metalMat.color.lerp(M.c, 0.085);
metalMat.roughness += (M.rough - metalMat.roughness) * 0.085;
if (Math.abs(metalMat.color.r - M.c.r) + Math.abs(metalMat.color.g - M.c.g) + Math.abs(metalMat.color.b - M.c.b) > 0.004) done = false;
if (done) { metalMat.color.copy(M.c); metalMat.roughness = M.rough; anim.metalTo = null; }
}
function tick(now) {
requestAnimationFrame(tick);
if (!resize()) return;
var ms = now || 0, dt = Math.min(0.05, (ms - clock.last) / 1000 || 0.016);
clock.last = ms; clock.t += dt; clock.w = ms / 1000;
if (spin && !dragging) { swayT += dt; cam.tAz = Math.sin(swayT * 0.42) * 0.7; cam.tEl = 0.34 + Math.sin(swayT * 0.3) * 0.16; }
cam.az += (cam.tAz - cam.az) * 0.12; cam.el += (cam.tEl - cam.el) * 0.12;
cam.dist += (cam.tDist - cam.dist) * (anim.introDone ? 0.08 : 0.035);
if (!anim.introDone && Math.abs(cam.dist - cam.tDist) < 0.6) anim.introDone = true;
root.rotation.x = Math.sin(clock.t * 0.55) * 0.04; root.rotation.z = Math.sin(clock.t * 0.37) * 0.02;
keyLight.position.set(26 + Math.sin(clock.t * 0.42) * 24, 42 + Math.cos(clock.t * 0.31) * 9, 58 + Math.sin(clock.t * 0.27) * 14);
rimLight.position.set(-44 + Math.cos(clock.t * 0.23) * 18, 14, -36 + Math.sin(clock.t * 0.29) * 16);
stepSetting(); stepFire(dt); stepMetal();
var ce = Math.cos(cam.el), se = Math.sin(cam.el);
camera.position.set(Math.sin(cam.az) * ce * cam.dist, se * cam.dist, Math.cos(cam.az) * ce * cam.dist);
camera.lookAt(0, 0, 0);
renderer.render(scene, camera);
}
cvs.addEventListener("pointerdown", function (e) {
dragging = true; spin = false; document.getElementById("btnSpin").setAttribute("aria-pressed", "false"); lastX = e.clientX; lastY = e.clientY;
cvs.classList.add("s-drag");
if (cvs.setPointerCapture) { try { cvs.setPointerCapture(e.pointerId); } catch (x) {} }
});
cvs.addEventListener("pointermove", function (e) {
if (!dragging) return;
cam.tAz -= (e.clientX - lastX) * 0.0085;
cam.tEl = Math.max(-1.2, Math.min(1.35, cam.tEl + (e.clientY - lastY) * 0.0065));
lastX = e.clientX; lastY = e.clientY;
});
["pointerup", "pointercancel", "pointerleave"].forEach(function (k) { cvs.addEventListener(k, function () { dragging = false; cvs.classList.remove("s-drag"); }); });
cvs.addEventListener("wheel", function (e) { e.preventDefault(); userZoomed = true; cam.tDist = Math.max(40, Math.min(300, cam.tDist + e.deltaY * 0.1)); }, { passive: false });
function btn(label, meta, pressed, onClick, swatch) {
var b = document.createElement("button");
b.className = "s-opt"; b.type = "button"; b.setAttribute("aria-pressed", pressed ? "true" : "false");
if (swatch) { var s = document.createElement("span"); s.className = "s-sw"; s.style.background = swatch; b.appendChild(s); }
var n = document.createElement("span"); n.className = "s-nm"; n.textContent = label; b.appendChild(n);
if (meta) { var m = document.createElement("span"); m.className = "s-meta"; m.textContent = meta; b.appendChild(m); }
b.addEventListener("click", onClick);
return b;
}
var SWATCH = { roman: "linear-gradient(135deg,#F4F7FA,#B7C1CB 55%,#78838E)", arabic: "linear-gradient(135deg,#F4F7FA,#B7C1CB 55%,#78838E)", red: "linear-gradient(135deg,#E0574C,#9E1F17)", blue: "linear-gradient(135deg,#4E8FD6,#123E77)", green: "linear-gradient(135deg,#5BC48C,#146B3F)", purple: "linear-gradient(135deg,#C46BE0,#6E2297)", white: "linear-gradient(135deg,#FFFFFF,#D5D9DE)", skel: "linear-gradient(135deg,#D7DEE6,#5B646E)" };
function renderOptions() {
var S = STYLES[state.style];
var o1 = document.getElementById("optStyle"); o1.textContent = "";
Object.keys(STYLES).forEach(function (k) {
o1.appendChild(btn(STYLES[k].name, "", state.style === k, function () {
if (state.style === k) return;
state.style = k; build(); renderOptions();
}, SWATCH[k]));
});
document.getElementById("styleBlurb").textContent = S.blurb;
var oN = document.getElementById("optNum"); oN.textContent = "";
Object.keys(NUMCOL).forEach(function (k) {
oN.appendChild(btn(NUMCOL[k].name, "", state.num === k, function () {
if (state.num === k) return;
state.num = k; retexture(); renderOptions();
}, NUMCOL[k].sw || NUMCOL[k].col));
});
document.getElementById("numBlurb").textContent = (state.num === "rainbow") ? "Each numeral in its own colour, around the dial." : NUMCOL[state.num].name + " numerals, " + (S.numerals === "arabic" ? "Arabic" : "Roman") + ", outlined so they read on the face.";
var oT = document.getElementById("optTone"); oT.textContent = "";
Object.keys(TONES).forEach(function (k) {
oT.appendChild(btn(TONES[k].name, "", state.tone === k, function () {
if (state.tone === k) return;
state.tone = k;
anim.metalTo = { c: new THREE.Color(TONES[k].col), rough: TONES[k].rough };
renderOptions(); paintReadout(null);
}, TONES[k].sw));
});
var o2 = document.getElementById("optStone"); o2.textContent = "";
Object.keys(STONES).forEach(function (k) {
o2.appendChild(btn(STONES[k].name, money(STONES[k].base), state.stone === k, function () {
if (state.stone === k) return;
state.stone = k; renderOptions(); paintReadout(null);
}));
});
document.getElementById("stoneBlurb").textContent = STONES[state.stone].blurb;
paintQuote();
}
function paintQuote() {
var S = STYLES[state.style], st = STONES[state.stone];
document.getElementById("qLabel").textContent = S.name + " · " + NUMCOL[state.num].name + " numerals · " + TONES[state.tone].name + " · " + st.name;
document.getElementById("qPrice").textContent = money(st.base);
document.getElementById("qNote").textContent = "Every style is the same price; only the stone changes it. About a week on the bench, then shipping on top.";
paintCta();
}
function paintCta() {
var ok = document.getElementById("agree").checked, a = document.getElementById("cta"), u = ok ? checkoutURL() : "";
if (u) { a.href = u; a.setAttribute("aria-disabled", "false"); } else { a.href = "#"; a.setAttribute("aria-disabled", "true"); }
document.getElementById("ctaNote").textContent = ok ? "Checkout opens with this watch in the cart." : "Tick the box to unlock checkout. Your build rides along on the order.";
}
var lastStoneCt = 0;
function paintReadout(stones) {
if (stones != null) lastStoneCt = stones;
document.getElementById("readout").innerHTML = "<b>" + STYLES[state.style].name + "</b> · " + TONES[state.tone].name + " · " + STONES[state.stone].name + "<br><b>" + lastStoneCt.toLocaleString("en-US") + "</b> stones set";
}
document.getElementById("btnSpin").addEventListener("click", function () { spin = !spin; swayT = 0; this.setAttribute("aria-pressed", spin ? "true" : "false"); });
document.getElementById("btnReset").addEventListener("click", function () { cam.tAz = 0; cam.tEl = 0.34; swayT = 0; userZoomed = false; anim.introDone = false; build(); cam.dist = cam.tDist + 60; });
document.getElementById("btnBare").addEventListener("click", function () { state.bare = !state.bare; this.setAttribute("aria-pressed", state.bare ? "true" : "false"); build(); });
(function () {
var h = (location.hash || "").replace("#", "");
if (STYLES[h]) state.style = h;
if (TONES[h]) state.tone = h;
if (NUMCOL[h] && !STYLES[h]) state.num = h;
var ol = document.getElementById("termsList");
TERMS.forEach(function (t) { var li = document.createElement("li"); li.textContent = t; ol.appendChild(li); });
document.getElementById("agree").addEventListener("change", paintCta);
document.getElementById("cta").addEventListener("click", function (e) { if (this.getAttribute("aria-disabled") === "true") { e.preventDefault(); document.getElementById("agree").focus(); } });
})();
init();
renderOptions();
build();
requestAnimationFrame(tick);
})();
